export default {
  // 修改采购订单
  updateYcPurchaseOrder: '/ygsjzs/ycPurchaseOrder/updateYcPurchaseOrder',
  // 删除采购订单
  deleteYcPurchaseOrder: '/ygsjzs/ycPurchaseOrder/deleteYcPurchaseOrder',

  // 查询采购订单详情
  selectYcPurchaseOrderByOrderId: '/ygsjzs/ycPurchaseOrder/selectYcPurchaseOrderByOrderId',
  // 查询采购订单列表
  selectYcPurchaseOrderByList: '/ygsjzs/ycPurchaseOrder/selectYcPurchaseOrderByList',
  // 采购订单统计
  selectYcPurchaseOrderCount: '/ygsjzs/ycPurchaseOrder/selectYcPurchaseOrderCount'
}
